import Vue from 'vue';
import PoppinsCondensedFooter from '@/components/condensed_footer/PoppinsCondensedFooter.vue';

export default () => {
  const footerNode = document.getElementById('footer');

  if (footerNode) {
    new Vue({
      render: (h) => h(PoppinsCondensedFooter),
    }).$mount('#footer');
  }
};
